<template>
	<div class="eia-address-form">
		<div class="eia-address-form__address-lines">
			<template v-for="( addressLine, $index ) in addressLines">
				<eia-form-group
					:key="$index"
					class="eia-address-form__address-line"
					:id="`address-line-${$index}`"
					variation="stacked">
					<span slot="label">Address Line {{ $index + 1 }}</span>

					<eia-validated-input
						:id="`address-line-${$index}`"
						type="text"
						:validators="validators"
						:show-error-indentation="true"
						placeholder=""
						v-model="addressLines[ $index ]"
						@input="onFieldInput"
						@error="onAddressLineError">
					</eia-validated-input>
				</eia-form-group>
			</template>

			<eia-link
				v-if="showAddAddressLine"
				class="eia-address-form__add-address-line"
				@click="onAddAddressLineClick">
				+ another address line
			</eia-link>
		</div>

		<div class="eia-address-form__town-city">
			<eia-form-group
				id="town-city"
				variation="stacked">
				<span slot="label">Town or City</span>

				<eia-validated-input
					id="town-city"
					type="text"
					:validators="townCityValidators"
					:show-error-indentation="true"
					placeholder=""
					v-model="townCity"
					@input="onFieldInput"
					@error="onTownCityError">
				</eia-validated-input>
			</eia-form-group>
		</div>

		<div class="eia-address-form__country">
			<eia-form-group
				id="country"
				variation="stacked">
				<span slot="label">Country</span>

				<eia-validated-input
					id="country"
					type="text"
					:validators="countryValidators"
					:show-error-indentation="true"
					placeholder=""
					v-model="country"
					@input="onFieldInput"
					@error="onCountryError">
				</eia-validated-input>
			</eia-form-group>
		</div>

		<div class="eia-address-form__postcode">
			<eia-form-group
				id="postcode"
				variation="stacked">
				<span slot="label">Postcode</span>

				<eia-validated-input
					id="postcode"
					type="text"
					:validators="postcodeValidators"
					:show-error-indentation="true"
					placeholder=""
					v-model="postcode"
					@input="onFieldInput"
					@error="onPostcodeError">
				</eia-validated-input>
			</eia-form-group>
		</div>
	</div>
</template>

<script>
import {
	notEmpty,
	notEmptyCustom,
	postcode,
} from '@/utils/validators';

export default {
	name: 'eia-address-form',

	data() {
		return {
			validators: [ notEmpty ],
			townCityValidators: [
				notEmptyCustom( 'Please tell us what town or city the site is in' ),
			],

			// No validators for Country, since it's more than likely to be the UK
			countryValidators: [],
			postcodeValidators: [
				notEmptyCustom( 'Please enter the postcode of your site' ),
				postcode,
			],

			addressLines: [ '' ],
			townCity: '',
			country: '',
			postcode: '',
			errors: {
				addressLines: false,
				townCity: false,
				country: false,
				postcode: false,
			},
			hasErrors: false,
		};
	},

	computed: {
		showAddAddressLine() {
			return this.addressLines.length < 3;
		},
	},

	methods: {
		onAddAddressLineClick() {
			this.addressLines.push( '' );
		},

		onAddressLineError( err ) {
			this.onErrorDelegate( 'addressLines', err );
		},

		onTownCityError( err ) {
			this.onErrorDelegate( 'townCity', err );
		},

		onCountryError( err ) {
			this.onErrorDelegate( 'country', err );
		},

		onPostcodeError( err ) {
			this.onErrorDelegate( 'postcode', err );
		},

		onErrorDelegate( field, err ) {
			this.errors[ field ] = err;

			this.hasErrors = Object.values( this.errors ).some( d => d !== false );

			if( this.hasErrors ) {
				this.emitErrorEvent();
			}
			else {
				this.emitInputEvent();
			}
		},

		onFieldInput() {
			if( this.hasErrors ) {
				this.emitErrorEvent();
			}
			else {
				this.emitInputEvent();
			}
		},

		emitErrorEvent() {
			this.$emit( 'error', this.errors );
		},

		emitInputEvent() {
			this.$emit( 'input', {
				addressLines: this.addressLines,
				townCity: this.townCity,
				country: this.country,
				postcode: this.postcode,
			} );
		},
	},
};
</script>

<style lang="scss">
.eia-address-form {
	.eia-form-group {
		margin: 24px 0;
	}

	.eia-validated-input {
		width: 100%;
	}

	&__add-address-line {
		display: block !important;
		margin-top: -16px;
	}

	&__address-line {
		max-width: 400px;
	}

	&__town-city,
	&__country {
		max-width: 300px;
	}

	&__postcode {
		input {
			max-width: 160px !important;
		}
	}
}
</style>
